/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Email_Purpose_FixedInputs */



/**
* | output |
* | --- |
* | "Fixed: members consented to this wording." |
*
* @param {Developer_Email_Purpose_FixedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_email_purpose_fixed = /** @type {((inputs?: Developer_Email_Purpose_FixedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Email_Purpose_FixedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Figé : les membres ont consenti à cette formulation.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fijo: los miembros dieron su consentimiento a esta redacción.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fixo: os membros consentiram com este texto.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fisso: i membri hanno acconsentito a questa formulazione.")
	return /** @type {LocalizedString} */ ("Fixed: members consented to this wording.")
});